import React, { createContext, useContext, useState, useRef, useCallback } from "react";
import API from "../API/newIndex";

export const AuthorContext = createContext({
  authorsList: [],
  setAuthorsList: () => {},
  fetchAuthors: () => {},
  isAuthorsLoading: false,
});

export const AuthorProvider = ({ children }) => {
  const [authorsList, setAuthorsList] = useState([]);
  const [isAuthorsLoading, setIsAuthorsLoading] = useState(false);
  const authorsListRef = useRef(authorsList);
  authorsListRef.current = authorsList;
  const isFetching = useRef(false);

  const fetchAuthors = useCallback(async (force = false) => {
    if (!force && authorsListRef.current && authorsListRef.current.length > 0) {
      return authorsListRef.current;
    }
    if (isFetching.current) return;

    isFetching.current = true;
    setIsAuthorsLoading(true);
    try {
      const data = await API({
        url: `/admin/blog/getBlogAuthors`,
        method: "get",
      });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        const list = result?.data || result?.records || (Array.isArray(result) ? result : []);
        setAuthorsList(list);
        authorsListRef.current = list;
        return list;
      }
    } catch (error) {
      console.error("Error fetching blog authors:", error);
    } finally {
      isFetching.current = false;
      setIsAuthorsLoading(false);
    }
  }, []);

  return (
    <AuthorContext.Provider
      value={{
        authorsList,
        setAuthorsList,
        fetchAuthors,
        isAuthorsLoading,
      }}
    >
      {children}
    </AuthorContext.Provider>
  );
};

export const useAuthor = () => {
  const context = useContext(AuthorContext);
  if (!context) {
    throw new Error("useAuthor must be used within an AuthorProvider");
  }
  return context;
};

export default AuthorContext;
